import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  banners: [],
  webBanners: [],
  contacts: [],
  titles: {
    home: [],
  },
  loading: false,
  error: null,
  success: false,
};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    // Get all banners
    getBannersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getBannersSuccess(state, action) {
      state.loading = false;
      state.banners = action.payload;
      state.success = true;
    },
    getBannersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Create banner
    createBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    createBannerSuccess(state, action) {
      state.loading = false;
      state.banners.push(action.payload);
      state.success = true;
    },
    createBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update banner
    updateBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateBannerSuccess(state, action) {
      state.loading = false;
      state.banners = state.banners.map((banner) =>
        banner._id === action.payload._id ? action.payload : banner
      );
      state.success = true;
    },
    updateBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Delete banner
    deleteBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteBannerSuccess(state, action) {
      state.loading = false;
      state.banners = state.banners.filter(
        (banner) => banner._id !== action.payload
      );
      state.success = true;
    },
    deleteBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get all Web banners
    getWebBannersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getWebBannersSuccess(state, action) {
      state.loading = false;
      state.webBanners = action.payload;
      state.success = true;
    },
    getWebBannersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Create Web banner
    createWebBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    createWebBannerSuccess(state, action) {
      state.loading = false;
      state.webBanners.push(action.payload);
      state.success = true;
    },
    createWebBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update Web banner
    updateWebBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateWebBannerSuccess(state, action) {
      state.loading = false;
      state.webBanners = state.webBanners.map((webBanners) =>
        webBanners._id === action.payload._id ? action.payload : webBanners
      );
      state.success = true;
    },
    updateWebBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Delete Web banner
    deleteWebBannerStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteWebBannerSuccess(state, action) {
      state.loading = false;
      state.webBanners = state.webBanners.filter(
        (webBanners) => webBanners._id !== action.payload
      );
      state.success = true;
    },
    deleteWebBannerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get titles
    getTitlesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTitlesSuccess(state, action) {
      state.loading = false;
      state.titles = action.payload;
      state.success = true;
    },
    getTitlesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update titles
    updateTitlesStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateTitlesSuccess(state, action) {
      state.loading = false;
      state.titles = action.payload;
      state.success = true;
    },
    updateTitlesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get Contact
    getContactsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getContactsSuccess(state, action) {
      state.loading = false;
      state.contacts = action.payload;
      state.success = true;
    },
    getContactsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetContentState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getBannersStart,
  getBannersSuccess,
  getBannersFailure,
  createBannerStart,
  createBannerSuccess,
  createBannerFailure,
  updateBannerStart,
  updateBannerSuccess,
  updateBannerFailure,
  deleteBannerStart,
  deleteBannerSuccess,
  deleteBannerFailure,

  getWebBannersStart,
  getWebBannersSuccess,
  getWebBannersFailure,
  createWebBannerStart,
  createWebBannerSuccess,
  createWebBannerFailure,
  updateWebBannerStart,
  updateWebBannerSuccess,
  updateWebBannerFailure,
  deleteWebBannerStart,
  deleteWebBannerSuccess,
  deleteWebBannerFailure,

  getTitlesStart,
  getTitlesSuccess,
  getTitlesFailure,
  updateTitlesStart,
  updateTitlesSuccess,
  updateTitlesFailure,
  resetContentState,
  getContactsStart,
  getContactsSuccess,
  getContactsFailure,
} = contentSlice.actions;

export default contentSlice.reducer;
